/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const GlobalFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M2.05 13h5.48a18 18 0 0 0 2.92 8.88A10 10 0 0 1 2.05 13m0-2a10 10 0 0 1 8.4-8.88A18 18 0 0 0 7.53 11zm19.9 0h-5.48a18 18 0 0 0-2.92-8.88 10 10 0 0 1 8.4 8.88m0 2a10 10 0 0 1-8.4 8.88A18 18 0 0 0 16.47 13zM9.53 13h4.94A16 16 0 0 1 12 20.6 16 16 0 0 1 9.53 13m0-2A16 16 0 0 1 12 3.4a16 16 0 0 1 2.47 7.6z" />
  </Icon>
);
